export default __webpack_public_path__ + "static/media/about.76a75fee.svg";